/**
 * Bank Payment Source used to identify the Bank MID.
 */
export type BankSource =
  | 'giftcard'
  | 'webordering'
  | 'billing'
  | 'invoicing'
  | 'SOURCE_NOT_DEFINED';
